import { twMerge } from 'tailwind-merge';
import { PRODUCT_NOT_FOUND_IMG_URL } from '~/utils/constants';
import Badge from './Badge';

function Quantity({
  original,
  available,
}: {
  original?: number;
  available?: number;
}) {
  const hasAvailable = available !== undefined && original !== available;

  return original !== undefined ?
      <>
        <span className="sr-only">Quantity</span>
        {hasAvailable && <span>{available} of</span>}
        <span>{original}</span>
      </>
    : <>
        <span className="sr-only">Quantity none</span>
        <span>-</span>
      </>;
}

type Props = {
  alt: string | null;
  src?: string | null;
  quantity?: number;
  remainingReturnableQuantity?: number;
  variant?: 'regular' | 'small' | 'full';
};

export default function ProductImage({
  src,
  alt,
  variant = 'regular',
  quantity,
  remainingReturnableQuantity,
}: Props) {
  return (
    <div
      className={twMerge(
        'relative rounded-sm border border-outline bg-white',
        variant !== 'full' && 'shrink-0 self-start',
        variant === 'regular' && 'size-20',
        variant === 'small' && 'size-12',
        variant === 'full' && 'size-full',
      )}
    >
      <img
        src={src ?? PRODUCT_NOT_FOUND_IMG_URL}
        alt={alt ?? 'Product'}
        className="size-full object-contain"
        onError={({ currentTarget }) => {
          // eslint-disable-next-line no-param-reassign
          currentTarget.onerror = null;
          if (currentTarget.src !== PRODUCT_NOT_FOUND_IMG_URL) {
            // eslint-disable-next-line no-param-reassign
            currentTarget.src = PRODUCT_NOT_FOUND_IMG_URL;
          }
        }}
      />
      {quantity !== undefined && (
        <Badge className="absolute -top-2 -right-2">
          <Quantity
            original={quantity}
            available={remainingReturnableQuantity}
          />
        </Badge>
      )}
    </div>
  );
}
